import React from "react";
import { Col, Form, Image, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { PROPOSAL_SET_VALUES } from "../../store/constants/proposalConstants";
import { useDispatch } from "react-redux";

const ProposalPreviewFormFooter = () => {
  const { project_name, bid_amount, proposal_template, scope_name, ai_pricing } = useSelector(
    (state) => state.proposalValues
  );
  const userDetails = useSelector((state) => state.userDetails);
  const { user } = userDetails;
  const sections = useSelector((state) => state.proposalSections);
  const dispatch = useDispatch();
  // let bidAmount = bid_amount?.replace(",", "");
  return (
    <>
      {sections.footer ? (
        user?.trade !== "painting" ?
        <>
          <Row className="d-flex justify-content-between py-4">
            <div className="col-md-10">
              <span className="fw-bolder">{user?.company_name?.toUpperCase()}</span>{" "}
              - {scope_name} for{" "}
              <span className="fw-bolder">{project_name?.toUpperCase()} </span>
              {bid_amount === "" ? "" : `$${parseInt(bid_amount).toLocaleString()}`}
            </div>
          </Row>
          {user?.file_url && (
            <Row>
              <Col className="text-end">
                {sections.logo? (
                  <Image
                    src={user?.file_url}
                    style={{ width: "`50px", height: "50px" }}
                  />
                ): ""}
              </Col>
            </Row>
          )}
        </>
        :
        <>
          {user?.file_url && (
            <Row>
              <Col className="text-end">
                {sections.logo? (
                  <Image
                    src={user?.file_url}
                    style={{ width: "`50px", height: "50px" }}
                  />
                ): ""}
              </Col>
            </Row>
          )}
          <Row className="text-center">
            <span className="fw-bolder">{scope_name} - for {project_name?.toUpperCase()} </span>
          </Row>
          {ai_pricing ? 
            <Row className="text-center d-flex justify-content-center">
              <Form.Control
                style={{ maxWidth: 'max-content' }}
                type="number"
                placeholder="Enter bid amount"
                value={bid_amount}
                onChange={(e) => dispatch({
                  type: PROPOSAL_SET_VALUES,
                  payload: {
                    bid_amount: e.target.value
                  }
                })}
              />
            </Row>:
            <Row className="text-center">
              <span>{bid_amount === "" ? "" : `$${parseInt(bid_amount).toLocaleString()}`}</span>
            </Row>
          }
        </>
      ) : ""}
    </>
  );
};

export default ProposalPreviewFormFooter;
